import { Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProductsService } from '../products.service';
import { ProductSubCategory } from '../products.model';

@Component({
  selector: 'app-sub-category-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './sub-category-modal.component.html',
  styleUrls: ['./sub-category-modal.component.scss']
})
export class SubCategoryModalComponent implements OnInit {
  @Input() subCategories: ProductSubCategory[] = [];
  @Input() categoryId!: string;
  editingSubCategory: ProductSubCategory | null = null;

  subCategoryForm: FormGroup;
  private fb = inject(FormBuilder);
  private productService = inject(ProductsService);
  private toastr = inject(ToastrService);
  public activeModal = inject(NgbActiveModal);

  constructor() {
    this.subCategoryForm = this.fb.group({
      name: [''],
      description: ['']
    });
  }

  ngOnInit(): void {}

  editSubCategory(sub: ProductSubCategory) {
    this.editingSubCategory = sub;
    this.subCategoryForm.patchValue({
      name: sub.name,
      description: sub.description,
    });
  }

  saveSubCategory() {
    if (this.subCategoryForm.invalid) {
      this.subCategoryForm.markAllAsTouched();
      return;
    }
    const payload = {
      ...this.subCategoryForm.value,
      categoryId: this.categoryId,
      isActive: true,
    };
    if (this.editingSubCategory) {
      this.productService.updateSubCategory(this.editingSubCategory.id, payload).subscribe({
        next: (res: ProductSubCategory) => {
          const idx = this.subCategories.findIndex(s => s.id === res.id);
          if (idx > -1) {
            this.subCategories[idx] = res;
          }
          this.toastr.success('Sub Category updated');
          this.editingSubCategory = null;
          this.subCategoryForm.reset();
        },
        error: () => this.toastr.error('Update failed')
      });
    } else {
      this.productService.addSubCategory(payload).subscribe({
        next: (res: any) => {
          this.toastr.success('Sub Category saved');
          this.activeModal.close(res);
        },
        error: () => this.toastr.error('Save failed')
      });
    }
  }
}
